import {
    Grid,
    Paper
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import AutoComplete from "../../../components/Comman/AutoComplete";
import NewMultipleSelect from "../../../components/Comman/NewMultipleSelect";
import { ButtonCompo } from "../../../components/Comman/Button";
import { LabelCompo } from "../../../components/Comman/Label";
import { redColor, titleColor } from "../../../config/ColorObj";
import endpoint from "../../../config/endpoints";
import {
    noInternetMsg,
    serverMsg,
    updateData,
    updateFailed,
    updateMsg
} from "../../../config/messageconstant";
import { getSalesExecutiveForReportingManager, getSalesExecutiveByStockHolderType } from "../../../Slice/salesExecutive.slice";
import { getStockStakeHolderType, getStockStakeHolderTypeForReportingConfig } from "../../../Slice/stockStakeHolderType.slice";
import { apiGet, apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";

const ReportingConfiguration = ({
    showLoador,
    showNotification,
    getStockStakeHolderType,
    getSalesExecutiveForReportingManager,
    getSalesExecutiveByStockHolderType,
    stakeHolderTypeList,
    salesExecutiveList,
    getStockStakeHolderTypeForReportingConfig,
}) => {
    const [salesTeamType, setSalesTeamType] = useState("");
    const [salesTeam, setSalesTeam] = useState([]);
    const [reportingType, setReportingType] = useState("");
    const [reportingSalesTeam, setReportingSalesTeam] = useState("");
    const [formErrors, setFormErrors] = useState({});
    const [salesTeamValue, setSalesTeamValue] = useState([]);


    const changeHandlerForDropdown = async (name, dropdown) => {
        if (name === "salesTeamType") {
            setSalesTeamType(dropdown);

            if (dropdown) {
                const stakeholderIdsList = dropdown.split(",");
                showLoador({ loador: true });
                await getSalesExecutiveByStockHolderType({ stockStakeHolderId: stakeholderIdsList })
                    .then(({ response, success }) => {
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        } else {
                            setSalesTeam(response);

                        }
                    });
            } else {
                setSalesTeam([]);
                setReportingType("");
                setReportingSalesTeam("");
            }


        } else if (name === "reportingType") {
            setReportingType(dropdown);
            if (dropdown) {
                showLoador({ loador: true });
                const { success } = await getSalesExecutiveForReportingManager({ stockStakeHolderId: dropdown });
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                } else {
                }
            }
        } else if (name === "reportingSalesTeam") {
            setReportingSalesTeam(dropdown);
        }
    };

    const checkValidation = () => {
        let formErrors = {};
        let formIsValid = true;

        if (salesTeamType === "" || salesTeamType === null) {
            formIsValid = false;
            formErrors["salesTeamTypeError"] = "Stock Holder Type Required";
        }
        if (salesTeam.length == 0 || salesTeam === null) {
            formIsValid = false;
            formErrors["salesTeamError"] = "Sales Team Required";
        }
        if (reportingType === "" || reportingType === null) {
            formIsValid = false;
            formErrors["reportingTypeError"] = "Reporting Type Reqquired";
        }
        if (reportingSalesTeam === "" || reportingSalesTeam === null) {
            formIsValid = false;
            formErrors["reportingSalesTeamError"] = "Reporting Person Required";
        }

        setFormErrors(formErrors);
        return formIsValid;
    };

    useEffect(() => {
        if (navigator.onLine) {
            showLoador({ loador: true });
            getStockStakeHolderType({ userTypeIds: "3,4" }).then(({ success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });


            showLoador({ loador: true });
            getStockStakeHolderType({ userTypeIds: "3,4" }).then(({ success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }, []);


    const saveData = () => {
        if (checkValidation()) {
            let salesTeamId = salesTeam !== null ? salesTeam : [];
            let reportingManagerId = reportingSalesTeam !== null ? reportingSalesTeam : "";
            let reportingManagerTypeId = reportingType !== null ? reportingType : "";


            let dataToSend = {
                salesTeamIds: salesTeamId,
                reportingManagerId: reportingManagerId,
                reportingManagerTypeId: reportingManagerTypeId,
            }

            console.log(dataToSend);

            swal({
                title: "Are you sure?",
                text: updateData,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    apiPost({
                        url:
                            endpoint.salesExecutive + "/update-reporting-for-sales-team",
                        postBody: dataToSend,
                    }).then(({ success }) => {
                        showLoador({ loador: false });
                        if (success) {
                            showNotification({
                                msg: updateMsg,
                            });
                            window.location.reload();
                        } else {
                            showNotification({
                                msg: updateFailed,
                                severity: "error",
                            });
                        }
                    });
                }
            });
        }

    }


    const multiSelectHandler = async (value, name) => {


        let updatedValue = [...value];

        const isAllSelected = updatedValue.includes("all");
        if (isAllSelected) {
            let salesTeamIds = [];
            if (name === "salesTeam") {
                salesTeamIds = salesExecutiveList.salesExecutiveByStockHolderType.map((data) => data.id);
                setSalesTeamValue(["all"]);
                setSalesTeam(salesTeamIds)
                setReportingType("");
            }
        } else {
            if (name === "salesTeam") {
                setSalesTeamValue(updatedValue);
                setSalesTeam(updatedValue)
                setReportingType("");
            }
        }

        if (value) {
            showLoador({ loador: true });
            await getStockStakeHolderTypeForReportingConfig({ userTypeIds: "3,4" })
                .then(async ({ response, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    }
                });
        }

    };


    return (
        <>
            <Paper
                sx={{
                    p: 2,
                    borderRadius: 2,
                }}
                elevation={0}
            >
                <div>
                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        container
                        justifyContent="space-between"
                    >
                        <Grid
                            item
                            sm={6}
                            xs={8}
                            md={6}
                            lg={6}
                            container
                            justifyContent="space-evenly"
                        >
                            <Grid item xs={12} md={5} sm={5}>
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16, color: redColor }}
                                    label="*"
                                />
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16, color: titleColor }}
                                    label="Sales Team Type:"
                                />
                            </Grid>
                            <Grid item xs={12} md={7} sm={7}>
                                <AutoComplete
                                    keyColName={"id"}
                                    placeHolder="Select Sales Team Type"
                                    value={salesTeamType}
                                    name={"salesTeamType"}
                                    options={stakeHolderTypeList?.stockStakeHolderType}
                                    errorText={
                                        formErrors["salesTeamTypeError"]
                                            ? formErrors["salesTeamTypeError"]
                                            : ""
                                    }
                                    isError={
                                        formErrors["salesTeamTypeError"]
                                            ? formErrors["salesTeamTypeError"]
                                            : ""
                                    }
                                    onChange={changeHandlerForDropdown}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            sm={6}
                            xs={8}
                            md={6}
                            lg={6}
                            container
                            justifyContent="space-evenly"
                        >
                            <Grid item xs={12} md={5} sm={5}>
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16, color: redColor }}
                                    label="*"
                                />
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16, color: titleColor }}
                                    label="Sales Team :"
                                />
                            </Grid>
                            <Grid item xs={12} md={7} sm={7}>
                                <NewMultipleSelect
                                    er={
                                        formErrors["salesTeamError"]
                                            ? formErrors["salesTeamError"]
                                            : ""
                                    }
                                    label={"Select Sales Team"}
                                    name1="salesTeam"
                                    value1={salesTeamValue}
                                    names={[
                                        { id: "all", name: "All" },
                                        ...salesExecutiveList?.salesExecutiveByStockHolderType,
                                    ]}
                                    onChange={multiSelectHandler}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <br />

                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        container
                        justifyContent="space-between"
                    >
                        <Grid
                            item
                            sm={6}
                            xs={8}
                            md={6}
                            lg={6}
                            container
                            justifyContent="space-evenly"
                        >
                            <Grid item xs={12} md={5} sm={5}>
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16, color: redColor }}
                                    label="*"
                                />
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16, color: titleColor }}
                                    label="Reporting Person Type :"
                                />
                            </Grid>
                            <Grid item xs={12} md={7} sm={7}>
                                <AutoComplete
                                    keyColName={"id"}
                                    placeHolder="Select Reporting Person Type"
                                    value={reportingType}
                                    name={"reportingType"}
                                    options={stakeHolderTypeList?.stockStakeHolderTypeForReportingConfig}
                                    errorText={formErrors["reportingTypeError"] ? formErrors["reportingTypeError"] : ""}
                                    isError={formErrors["reportingTypeError"] ? formErrors["reportingTypeError"] : ""}
                                    onChange={changeHandlerForDropdown}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            sm={6}
                            xs={8}
                            md={6}
                            lg={6}
                            container
                            justifyContent="space-evenly"
                        >
                            <Grid item xs={12} md={5} sm={5}>
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16, color: redColor }}
                                    label="*"
                                />
                                <LabelCompo
                                    className="text-black"
                                    style={{ fontSize: 16, color: titleColor }}
                                    label="Reporting Person :"
                                />
                            </Grid>
                            <Grid item xs={12} md={7} sm={7}>
                                <AutoComplete
                                    keyColName={"id"}
                                    placeHolder="Select Reporting Person"
                                    value={reportingSalesTeam}
                                    name={"reportingSalesTeam"}
                                    options={salesExecutiveList?.salesExecutive}
                                    errorText={formErrors["reportingSalesTeamError"] ? formErrors["reportingSalesTeamError"] : ""}
                                    isError={formErrors["reportingSalesTeamError"] ? formErrors["reportingSalesTeamError"] : ""}
                                    onChange={changeHandlerForDropdown}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <br />

                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        rowSpacing={2}
                        columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                        container
                        justifyContent="right"
                        marginTop={2}
                    >
                        <ButtonCompo
                            size="medium"
                            onClick={saveData}
                            variant="contained"
                            name="Update"
                        />
                    </Grid>
                </div>
            </Paper>
        </>
    );
};
const mapStateToProps = (state) => ({
    stakeHolderTypeList: state.stockStakeHolderType,
    salesExecutiveList: state.salesExecutive,

});
const mapDispatchToProps = {
    showNotification,
    showLoador,
    getStockStakeHolderType,
    getStockStakeHolderTypeForReportingConfig,
    getSalesExecutiveForReportingManager,
    getSalesExecutiveByStockHolderType,
};
export default connect(mapStateToProps, mapDispatchToProps)(ReportingConfiguration);
